import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { IPopupScreenData } from 'src/app/common/models/popup-screen-data.model';
import { AccountDetails } from 'src/app/models/account-info.model';
import { LoanService } from 'src/app/services/loans/loan.service';
import { REFERENCE_KEY } from '../../../common/constants/base.constant';
import { BaseFpxFormComponent } from '../../../common/utils/base-fpx.form.component';
import { LoanDetails } from '../../../models/loan-details.model';
import { LoanRepaymentSchedule } from '../../../models/loan-repayment-schedule.model';
import { ServiceStock } from '../../../service-stock.service';
import {
  RepaymentScheduleHelper,
  RepaymentScheduleState,
} from './services/repayment-schedule.helper';
import { CalendarDay } from '../loan-ui/loan-ui.component';


@Component({
  selector: 'app-repayment-schedule',
  templateUrl: './repayment-schedule.component.html',
  styleUrls: ['./repayment-schedule.component.scss'],
  providers: [RepaymentScheduleHelper],
})
export class RepaymentScheduleComponent extends BaseFpxFormComponent<
  RepaymentScheduleHelper,
  RepaymentScheduleState
> {
  repaymentScheduleDetails: LoanRepaymentSchedule[];
  fromAccount: any;
  constructor(
    _formBuilder: FormBuilder,
    _router: Router,
    public _loanService: LoanService,
    public _repaymentScheduleHelper: RepaymentScheduleHelper,
    private services: ServiceStock,
    private dialogRef: MatDialogRef<RepaymentScheduleComponent>, 
    @Inject(MAT_DIALOG_DATA) private data: IPopupScreenData
  ) {
    super(_formBuilder, _router, _repaymentScheduleHelper);
  }

  @Input() instalmentDueDates;
  installmentDates: Array<any> = [];
  @Output() closeScheduler = new EventEmitter();
  activeAccountNumber: string;
  public calendar: CalendarDay[] = [];
  public monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  public displayMonth: string;
  public displayYear: number;
  private monthIndex: number = 0;
  private yearIndex: number = 0;
  public currenctMonth: number;
  selectedDate: any;
  showCalender: boolean = true;

  override doPreInit() {
    this.initializeForm();
    this.generateCalendarDays(this.monthIndex);
    this.activeAccountNumber = this.data.screenData.accountNumber;
    this.fetchLoanRepayScheduleDetails(this.activeAccountNumber);
    let selectedLoanInfo: LoanDetails =
      this._loanService.getLoanDetails(this.activeAccountNumber);
    this.formGroup.patchValue({
      loanInfo: selectedLoanInfo,
    });
  }

  override doPostInit() {
    let selectedLoanInfo: LoanDetails =
      this._loanService.getLoanDetails(this.activeAccountNumber);
    this.formGroup.patchValue({
      loanInfo: selectedLoanInfo,
    });
  }

  initializeForm() {
    this.addFormControl('loanInfo', '', [Validators.required]);
  }

  fetchLoanRepayScheduleDetails(loanNumber) {
    this._loanService
      .fetchLoanRepaymentSchedule(loanNumber)
      .subscribe((res) => {
        this.repaymentScheduleDetails = res;
      });
  }

  private generateCalendarDays(selectedDate?): void {
    this.calendar = [];

    // let startDate = this.installmentDates[0].split("/");

    let day: Date = new Date();
    // new Date().setFullYear(
    //   Number(startDate[2]) + this.yearIndex,
    //   Number(startDate[1]) - 1 + this.monthIndex,
    //   1
    // )

    this.displayMonth = this.monthNames[day.getMonth()];
    this.currenctMonth = day.getMonth();
    this.displayYear = day.getFullYear();

    let startingDateOfCalendar = this.getStartDateForCalendar(day);

    let dateToAdd = startingDateOfCalendar;
    let dateIndex = 42;
    let repeatedmonthIndex = 0;

    for (let i = 0; i < dateIndex; i++) {
      if (dateToAdd.getDate() === 1) {
        repeatedmonthIndex++;
      }
      repeatedmonthIndex === 2 && i <= 35 ? (dateIndex = 35) : '';
      this.calendar.push(new CalendarDay(new Date(dateToAdd)));
      dateToAdd = new Date(dateToAdd.setDate(dateToAdd.getDate() + 1));
    }
  }

  private getStartDateForCalendar(selectedDate: Date) {
    let lastDayOfPreviousMonth = new Date(selectedDate.setDate(1));
    let startingDateOfCalendar: Date = lastDayOfPreviousMonth;
    if (startingDateOfCalendar.getDay() != 1) {
      do {
        startingDateOfCalendar = new Date(
          startingDateOfCalendar.setDate(startingDateOfCalendar.getDate() - 1)
        );
      } while (startingDateOfCalendar.getDay() != 1);
    }

    return startingDateOfCalendar;
  }

  public increaseMonth() {
    this.monthIndex++;
    this.generateCalendarDays();
  }

  public decreaseMonth() {
    this.monthIndex--;
    this.generateCalendarDays();
  }

  public setCurrentMonth() {
    this.monthIndex = 0;
    this.generateCalendarDays();
  }

  public increaseYear() {
    this.yearIndex++;
    this.generateCalendarDays();
  }

  closeScheduleCalender() {
    this.closeScheduler.emit('close');
  }

  formatAmount(number) {
    return this.services.dataStore.formatAmount(number);
  }
  onChangeLoanList(accountNumber) {
    this.fetchLoanRepayScheduleDetails(accountNumber);
  }
}
